/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductSearchFacetValue
 */
export interface ProductSearchFacetValue {
    /**
     * 
     * @type {string}
     * @memberof ProductSearchFacetValue
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchFacetValue
     */
    label: string;
    /**
     * Exact matching SKU count for this facet value. Omitted when only a bounded estimate is available.
     * @type {number}
     * @memberof ProductSearchFacetValue
     */
    count?: number;
    /**
     * Estimated or lower-bound matching SKU count for this facet value, computed from the bounded facet window.
     * @type {number}
     * @memberof ProductSearchFacetValue
     */
    estimatedCount?: number;
    /**
     * Whether this facet value has matching SKUs under the current query and filters.
     * @type {boolean}
     * @memberof ProductSearchFacetValue
     */
    available: boolean;
}

/**
 * Check if a given object implements the ProductSearchFacetValue interface.
 */
// @ts-ignore
export function instanceOfProductSearchFacetValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "available" in value;

    return isInstance;
}

// @ts-ignore
export function ProductSearchFacetValueFromJSON(json: any): ProductSearchFacetValue {
    return ProductSearchFacetValueFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductSearchFacetValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSearchFacetValue {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'estimatedCount': !exists(json, 'estimated_count') ? undefined : json['estimated_count'],
        'available': json['available'],
    };
}

// @ts-ignore
export function ProductSearchFacetValueToJSON(value?: ProductSearchFacetValue | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
        'count': value.count,
        'estimated_count': value.estimatedCount,
        'available': value.available,
    };
}

